import {axiosClientAuth} from '../../utils/axiosClient'
import {REGULATORY_OPERATOR_KEY} from '../../../config/countryConfig'

export const SENDER_QUERY_KEY = 'sender-list'

interface SenderRecord {
  id: string
  sender_id: string
  sender_type: string
  category: string
  owner_id: string | null
  document_uri: string | null
  document_file_name: string | null
  status: Record<string, {active: boolean | null}>
  created_at: string
  updated_at: string
}

export interface SenderMapped {
  uuid: string
  name: string
  senderType: string
  category: string
  created_at: string
  status: 'pending' | 'approved' | 'rejected'
  documents: {name: string; url: string}[]
  ownerId: string | null
}

function mapSenderRecord(item: SenderRecord): SenderMapped {
  const active = item.status?.[REGULATORY_OPERATOR_KEY]?.active
  const status = active === true ? 'approved' : active === false ? 'rejected' : 'pending'
  const documents =
    item.document_uri != null
      ? [{name: item.document_file_name ?? 'Document', url: item.document_uri}]
      : []
  return {
    uuid: item.id,
    name: item.sender_id,
    senderType: item.sender_type,
    category: item.category,
    created_at: item.created_at,
    status,
    documents,
    ownerId: item.owner_id,
  }
}

export function fetchSenderList(params: {page: number; page_size: number; search?: string}) {
  return axiosClientAuth
    .get('/sender/', {
      params,
      transformResponse: (data) =>
        JSON.parse(data.replace(/"owner_id"\s*:\s*(\d{10,})/g, '"owner_id":"$1"')),
    })
    .then((res) => ({
      count: res.data.data.count as number,
      results: (res.data.data.results as SenderRecord[]).map(mapSenderRecord),
    }))
}

export function patchSenderStatus(id: string, active: boolean, reason: string) {
  return axiosClientAuth.patch(`/sender/${id}/status/`, {active, reason})
}

export function downloadSenderDocument(senderId: string): Promise<Blob> {
  return axiosClientAuth
    .get(`/sender/${senderId}/document/download/`, {responseType: 'blob'})
    .then((res) => res.data as Blob)
}
